/**
 * @file element-place.ts
 * @description Место и отступы элемента секции v4 (phase19.16, партия SB120,
 * этап 3а; uiux-sb120-stage3 §2.1, §3; данные db-design-sb120-stage3 §2):
 *  - `setElementSpace` — поле отступа px (`top/bottom/topPhone/bottomPhone`):
 *    `undefined` снимает ключ, пустой `space` убирается («обычно» — ритм
 *    колонки);
 *  - `overlayPlaceName` — место надписи на фото словами для сводки строки
 *    списка: 9 мест (x, y ∈ {0, 50, 100}) — «слева снизу», иначе числами.
 */

import type { SectionElement, SectionOverlay } from "@chaiberi/shared";

import { formatNumber } from "../site-fields/number-input";
import { ANCHOR_NAMES } from "./section-meta";

type Space = NonNullable<SectionElement["space"]>;

/** Поле отступа: `undefined` снимает ключ, пустой `space` убирается. */
export function setElementSpace(space: Space | undefined, key: keyof Space, value: number | undefined): Space | undefined {
  const next: Space = { ...(space ?? {}) };
  if (value === undefined) delete next[key];
  else next[key] = value;
  return Object.keys(next).length > 0 ? next : undefined;
}

const STEPS = [0, 50, 100] as const;

/** «слева снизу» для 9 мест, иначе «x 30 % · y 70 %». */
export function overlayPlaceName(overlay: Pick<SectionOverlay, "x" | "y">): string {
  const col = STEPS.indexOf(overlay.x as (typeof STEPS)[number]);
  const row = STEPS.indexOf(overlay.y as (typeof STEPS)[number]);
  if (col >= 0 && row >= 0) return ANCHOR_NAMES[row * 3 + col] ?? "в центре";
  return `x ${formatNumber(overlay.x, 0)} % · y ${formatNumber(overlay.y, 0)} %`;
}
